import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface DeleteTeamMemberModalInput {
  userName: string;
  teamName: string;
}

@Component({
  selector: 'delete-team-member-modal',
  templateUrl: 'delete-team-member-modal.component.pug',
})
export class DeleteTeamMemberModalComponent {
  @Output() close = new EventEmitter<boolean | undefined>();
  @Input() data!: DeleteTeamMemberModalInput;

  onDelete() {
    this.close.emit(true);
  }

  onClose() {
    this.close.emit(undefined);
  }
}
